import { makeStyles, withStyles } from '@material-ui/core/styles'

import Card from '@material-ui/core/Card'

export const ArticleCard = withStyles(theme => ({
  root: {
    borderRadius: '4px',
    '& .MuiCardMedia-media': {
      height: '100%',
      objectPosition: '50% 0',
    },
    '& .MuiCardContent-root': {
      background: theme.palette.secondary.light,
      color: theme.palette.secondary.contrastText,
      display: 'flex',
      flexDirection: 'column',
      height: theme.spacing(15),
      padding: theme.spacing(2),
    },
    '& .MuiTypography-body2': {
      lineHeight: '1.25em',
    },
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(1),
    },
  },
}), { withTheme: true })(Card)

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.grey[100],
    color: theme.palette.secondary.main,
    padding: theme.spacing(4),
  },
  iconButton: {
    background: theme.palette.grey.light,
    position: 'absolute',
    zIndex: '1000',
    top: '40%',
    '&:hover': {
      background: theme.palette.grey.dark,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  iconPrev: {
    left: '-20px',
  },
  iconNext: {
    right: '-20px',
  },
  icons: {
    color: '#000000',
  },
  articleWrapper: {
    '& .slick-dots': {
      bottom: '-35px',
    },
    '& .slick-dots li button:before': {
      fontSize: '26px',
      color: theme.palette.grey.dark,
    },
    '& .slick-dots li.slick-active button:before': {
      color: theme.palette.grey.darker,
    },
  },
  cardContent: {
    [theme.breakpoints.down('sm')]: {
      '& h5': {
        fontSize: '16px',
      },
    },
  },
  summary: {
    fontSize: '16px',
    fontWeight: '400',
    fontFamily: 'Nunito Sans',
    lineHeight: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
}))

export default useStyles
